import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { toastStore, Typography } from 'shared/ui'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { ClientsApi } from 'entities/Clients/api/clients'
import { type RowPendingClient } from 'entities/Clients/model/RowPendingClient'

export const cancelInvite = async (row: RowPendingClient, onSuccess: () => void) => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  const onCancelInvite = async () => {
    try {
      await ClientsApi.cancelInvite(row.origin.id)
      onSuccess()

      toastStore.add({
        type: 'success',
        title: 'Invite canceled',
      })
    } catch (error) {
      logger.error(error)
      toastStore.add({
        type: 'error',
        title: 'Something went wrong, try again.',
      })
    } finally {
      onClose()
    }
  }

  modalStore.addModal({
    type: ModalTypeList.WARNING,
    id: modalId,
    title: 'Cancel invite',
    desc: [
      'This will cancel the invitation for',
      <br key={'br'} />,
      <Typography
        key={row.email}
        ariaLabel='CancelInvite'
        variant='body-rg-regular'
        color='var(--content-primary-primary)'
      >
        {row.email}
      </Typography>,
    ],
    width: 280,
    primaryAction: {
      text: 'Cancel invite',
      onAction: onCancelInvite,
    },
    secondaryAction: {
      text: 'Keep invite',
      onAction: onClose,
    },
  })
}
